import { render } from "./cbox.vue?vue&type=template&id=2c73a814&scoped=true"
import script from "./cbox.vue?vue&type=script&lang=js"
export * from "./cbox.vue?vue&type=script&lang=js"

import "./cbox.vue?vue&type=style&index=0&id=2c73a814&lang=scss&scoped=true"

import exportComponent from "E:\\zhouwang\\work\\web_dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c73a814"]])

export default __exports__